var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_more",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("了解更多")])
}
var staticRenderFns = []

export { render, staticRenderFns }